import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

import s from './BecomeHost.css';

import ListPlaceStep1 from '../../components/ListPlaceStep1';
import history from '../../core/history';

class BecomeHost extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    mode: PropTypes.string,
    listId: PropTypes.number,
    formBaseURI: PropTypes.string,
    mode: PropTypes.string,
    isAuthenticated: PropTypes.bool,
    isAdminAuthenticated: PropTypes.bool
  };

  render() {
    const { formPage, formBaseURI, mode, listId, baseCurrency, step,pageId } = this.props;
    return (
      <div className={'existingPage'}>
        <ListPlaceStep1
          listId={listId}
          formPage={formPage}
          formBaseURI={formBaseURI}
          mode={mode}
          baseCurrency={baseCurrency}
          step={step}
          pageId={pageId}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
  isAdminAuthenticated: state.runtime.isAdminAuthenticated
});

export default connect(mapState)(injectIntl(withStyles(s)(BecomeHost)));